import * as ngCore from '@angular/core'

import * as state from '../../../../../../../../../../../state'
import * as element from '../../element'

@ngCore.Component({
  imports: [ngCore.forwardRef(() => element.Component)],
  selector: 'atn-mosaic-grid-column',
  standalone: true,
  styleUrl: './component.scss',
  templateUrl: './component.html',
})
export class Component {
  /**
   * @see {@link state.mosaic.endUser.currentRendering.models.page.Content.Element.Column}
   */
  public readonly columnSg =
    ngCore.input.required<state.mosaic.endUser.currentRendering.models.page.Content.Element.Column>(
      {
        alias: 'column',
      },
    )
}
